import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface MenuItem {
  id: string;
  name: string;
  description: string;
  price: number;
  categoryId: string;
  imageUrl?: string;
  isAvailable: boolean;
  options?: any;
  customization?: any;
  displayOrder: number;
  categories?: { id: string; name: string }[];
  startTime?: string;
  endTime?: string;
  daysOfWeek?: string[];
  isCurrentlyAvailable?: boolean;
  nextAvailabilityTime?: string | null;
}

export interface Category {
  id: string;
  name: string;
  description?: string;
  isActive: boolean;
  displayOrder: number;
}

interface MenuState {
  items: MenuItem[];
  categories: Category[];
  loading: boolean;
  error: string | null;
}

const initialState: MenuState = {
  items: [],
  categories: [],
  loading: false,
  error: null,
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    fetchMenuStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchMenuSuccess: (state, action: PayloadAction<{ items: MenuItem[]; categories: Category[] }>) => {
      state.loading = false;
      state.items = action.payload.items;
      state.categories = action.payload.categories;
    },
    fetchMenuFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateMenuItem: (state, action: PayloadAction<MenuItem>) => {
      const index = state.items.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    addMenuItem: (state, action: PayloadAction<MenuItem>) => {
      state.items.push(action.payload);
    },
    removeMenuItem: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(item => item.id !== action.payload);
    },
  },
});

export const {
  fetchMenuStart,
  fetchMenuSuccess,
  fetchMenuFailure,
  updateMenuItem,
  addMenuItem,
  removeMenuItem,
} = menuSlice.actions;

export default menuSlice.reducer; 